import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ZendeskAllArticlesContainer from '../../../containers/tools/zendesk/ZendeskAllArticlesContainer';
import ZendeskArticleDetailsContainer from '../../../containers/tools/zendesk/ZendeskArticleDetailsContainer';
import {
  HeaderRow,
  PageInfoContentWrapper,
  BackButton,
  RowDivider,
  ZendeskContainerRow,
} from './ZendeskComponent.styles';

class ZendeskComponent extends Component {
  render() {
    const getInfoForCurrentPage = (currentPage) => {
      switch (currentPage) {
        case 'allArticles':
          return {
            title: 'Additional Info',
            subtitle: 'All Articles',
            content: <ZendeskAllArticlesContainer />,
            backAction: this.props.showKnowledgeBasePage,
          };
        case 'articleDetails':
          return {
            title: 'Additional Info',
            subtitle: 'Article Details',
            content: <ZendeskArticleDetailsContainer />,
            backAction: this.props.showAllZendeskArticlesPage,
          };
        default:
          throw new Error(`unknown currentPage: ${currentPage}`);
      }
    };

    // Allows back navigation to navigate back to FAQ if user has selected an article
    const pageInfo = getInfoForCurrentPage(this.props.zendesk.currentPage);

    return (
      <div className="col-xs-12 ">
        <HeaderRow className="row">
          <div className="col-xs-8">
            {pageInfo.subtitle ? (
              <BackButton className="pull-left" onClick={pageInfo.backAction}>
                <img src="/images/curved-back-arrow.svg" alt="back-button" />
              </BackButton>
            ) : null}
            <div className="title">
              <span className="title-label">{pageInfo.title}</span>
            </div>
          </div>
        </HeaderRow>
        <RowDivider />
        <ZendeskContainerRow className="row">
          <PageInfoContentWrapper className="col-md-12 col-sm-12">{pageInfo.content}</PageInfoContentWrapper>
        </ZendeskContainerRow>
      </div>
    );
  }
}

ZendeskComponent.propTypes = {
  zendesk: PropTypes.shape({
    currentPage: PropTypes.string.isRequired,
  }).isRequired,
  showKnowledgeBasePage: PropTypes.func.isRequired,
  showAllZendeskArticlesPage: PropTypes.func.isRequired,
};

export default ZendeskComponent;
